import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Navigation from '../../components/Navigation'
import Footer from '../../components/Footer'
import { CreateClubsForm } from '.././FormPage'

const Section = styled.section`
  min-height: ${props => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${props => props.theme.body};
`

const Container = styled.div`
  width: 80%;
  min-height: 50vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`

const Container2 = styled.div`
  width: 80%;
  min-height: 130vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1{
      color: blue;
  }
  .text-2{
      color: orange;
  }
  .text-3{
      color: red;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};

  }
  @media (max-width: 48em) { 
    align-self: center;
    text-align:center;
  }
  @media (max-width: 40em){
    width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${props => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
    p span {
        color: orange;
    }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align:center;
  }
`

const Div2 = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 50px;

  p {
    color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${props => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
    button {
        margin: 10px 0;
        width: 100%;
        padding: 20px;
        border-radius: 20px;
        background-color: black;
        color: white;
        border: none;
        cursor: pointer;
    }
    @media (max-width: 64em) {
      width: 85%;
      flex-direction: column;
    }
    @media (max-width: 48em) {
      width: 85%;
      flex-direction: column;
      align-self: center;
      text-align: center;
    }
`

const DivShadow = styled.div`
    font-size: 20px;
    gap: 30px;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    items-align: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    p {
        color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
        font-size: ${props => props.theme.fontlg};
        font-weight: 600;
        margin-top: 10px;
    }
    button {
        margin: 10px 0;
        width: 100%;
        padding: 20px;
        border-radius: 20px;
        background-color: black;
        color: white;
        border: none;
        cursor: pointer;
    }
    @media (max-width: 64em) {
      width: 85%;
      flex-direction: column;
    }
    @media (max-width: 48em) {
      width: 85%;
      flex-direction: column;
      align-self: center;
      text-align: center;
      margin-bottom: 50px;
      
      .small {
        font-size: 30px;
        line-height: 10px;
      }
      p {
          margin-top: 20px;
          font-size: 18px;
      }
    }
  `

const MainContent = styled.main`
  width: 60%;
  @media (max-width: 48em) {
    width: 100%;
  }
  
`

const ImgContent = styled.main`
  width: 40%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
  }
  @media (max-width: 48em) {
    display: none;
  }
`

const CreateClub = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('userId');
    setIsLoggedIn(!!token); // true if token exists
  }, []);

  const handleFormSubmit = (data) => {
    console.log("Form data received from child:", data);
    
    // you can now use this data at the parent level
  };


  return (
    <Section id="Login">
      <Navigation />
        { isLoggedIn ? (
          <Container2>
            <DivShadow>
                <MainContent >
                  <CreateClubsForm onSubmitData={handleFormSubmit} />
                </MainContent>
                
                <ImgContent>
                    { 
                        
                    }
                  <img src="/createArt.webp" alt="" />
                </ImgContent>
            </DivShadow>
            
            {/* Add your art creation form or component here */}
          </Container2>
        ) : (
          <Container>
            <Div>
                <Title>
                    <span >Create Your</span> <span className="text-3">Art</span>
                </Title>
                <p> 
                    <Link to="/">Home</Link>
                    
                    <span> . Create</span>
                </p>
            </Div>
    
            <Div2>
                <p> Please connect your wallet to view this page </p>
                <Link to="/connect-wallet">
                    <button>
                        Connect  Wallet
                    </button>
                </Link>
            </Div2>
            <div>
    
            </div>
          </Container>
        )}
      
      <Footer />
    </Section>
  )
}

export default CreateClub